import axios from 'axios';

// Use relative path to leverage nginx proxy, or use environment variable if set
// The nginx.conf proxies /api to the backend container
const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_URL ? `${API_URL}/api` : '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth API
export const authAPI = {
  register: (username, email, password) =>
    api.post('/auth/register', { username, email, password }),
  login: (username, password) =>
    api.post('/auth/login', { username, password }),
  logout: () => api.post('/auth/logout'),
  getCurrentUser: () => api.get('/auth/me'),
};

// Board API
export const boardAPI = {
  getAll: () => api.get('/boards'),
  create: (title, description) => api.post('/boards', { title, description }),
  update: (id, data) => api.put(`/boards/${id}`, data),
  delete: (id) => api.delete(`/boards/${id}`),
};

// List API
export const listAPI = {
  create: (boardId, title) => api.post('/lists', { board_id: boardId, title }),
  update: (id, data) => api.put(`/lists/${id}`, data),
  delete: (id) => api.delete(`/lists/${id}`),
};

// Recipe API
export const recipeAPI = {
  create: (recipeData) => api.post('/recipes', recipeData),
  get: (id) => api.get(`/recipes/${id}`),
  update: (id, data) => api.put(`/recipes/${id}`, data),
  delete: (id) => api.delete(`/recipes/${id}`),
  search: (query) => api.get('/search', { params: { q: query } }),
  aiSearch: (query) => api.post('/recipes/ai-search', { query }),
  generateNutrition: (id) => api.post(`/recipes/${id}/generate-nutrition`),
  customize: (id, payload) => api.post(`/recipes/${id}/customize`, payload),
  customizeDraft: (recipe, instruction) =>
    api.post('/recipes/customize-draft', { recipe, instruction }),
  suggestFromIngredients: (ingredients) =>
    api.post('/recipes/suggest-from-ingredients', { ingredients }),
  importFromUrl: (url, listId) =>
    api.post('/recipes/import/url', { url, list_id: listId }),
  importFromFile: (file, listId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('list_id', listId);
    return api.post('/recipes/import/file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

// Upload API
export const uploadAPI = {
  uploadPhoto: (file, recipeId = null) => {
    const formData = new FormData();
    formData.append('file', file);
    if (recipeId) {
      formData.append('recipe_id', recipeId);
    }
    return api.post('/upload/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deletePhoto: (photoId) => api.delete(`/upload/photo/${photoId}`),
  deleteRecipeImage: (recipeId) => api.delete(`/recipes/${recipeId}/image`),
};

export default api;
